import React from 'react';
import MesaThalesConsultList from '../../../components/consult/list/mesa-thales-list';

export default () => {
  return <MesaThalesConsultList/>
}